import React from "react";

function Dashboard() {
  return <h1>Welcome to Admin Portal</h1>;
}

export default Dashboard;
